import { render, staticRenderFns } from "./show-v2.vue?vue&type=template&id=5960331a&scoped=true&"
import script from "./show-v2.vue?vue&type=script&lang=js&"
export * from "./show-v2.vue?vue&type=script&lang=js&"
import style0 from "./show-v2.vue?vue&type=style&index=0&id=5960331a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5960331a",
  null
  
)

export default component.exports